import React, { ElementType, ReactNode, useContext } from 'react';

import { DefaultBsComponent } from '../../types/module';

import { classNames } from '../../utils/style';
import PricingCardContext from './PricingCardContext';

export interface PricingHeaderProps extends DefaultBsComponent {
  title?: ReactNode;
  /** The HTML element to render the header as (default: 'h2') */
  as?: ElementType;
}

export interface PricingCardContextType {
  isDisabled?: boolean;
}

/**
 * Header component for pricing cards that displays the plan title.
 * Automatically handles disabled state from PricingCardContext.
 *
 * @example
 * ```tsx
 * <Header title="Enterprise Plan" />
 * <Header title="Basic Plan" as="h3" />
 * ```
 */
export const Header = ({ title, as: Component = 'h2', className }: PricingHeaderProps) => {
  const context = useContext<PricingCardContextType>(PricingCardContext);

  return (
    <Component
      className={classNames(
        'text-blue-101 text-[20px] mb-24',
        context?.isDisabled && 'text-silver-300',
        className,
      )}
    >
      {title}
    </Component>
  );
};
